import React, {Component} from "react";
import Iframe from "react-iframe";

export class Gallery extends Component {
    render() {
        return (
            <div id="portfolio" className="text-center">
                <div className="container">
                    <div className="section-title">
                        <h2>Portfolio</h2>
                    </div>
                    <div className="">
                        <div className="col-md-12 col-lg-12">
                            <div className="row justify-content-center">
                                <div className="portfolio-item col-md-6 col-lg-3 p-2">
                                    <div className="hover-bg">
                                        {" "}
                                        <a
                                            href="img/portfolio/05-large.jpg"
                                            title="Marian Beauty Shoot"
                                            data-lightbox-gallery="gallery1"
                                        >
                                            <div className="hover-text">
                                                <h4>marian</h4>
                                            </div>
                                            <img
                                                src="img/portfolio/05-small.jpg"
                                                className="img-fluid"
                                                alt="Gleamsonic Product Shoot"
                                            />{" "}
                                        </a>{" "}
                                    </div>
                                </div>
                                <div className="portfolio-item col-md-6 col-lg-3 p-2">
                                    <div className="hover-bg">
                                        {" "}
                                        <a
                                            href="img/portfolio/06-large.jpg"
                                            title="Abi Beauty Shoot"
                                            data-lightbox-gallery="gallery1"
                                        >
                                            <div className="hover-text">
                                                <h4>abi</h4>
                                            </div>
                                            <img
                                                src="img/portfolio/06-small.jpg"
                                                className="img-fluid"
                                                alt="Gleamsonic Product Shoot"
                                            />{" "}
                                        </a>{" "}
                                    </div>
                                </div>
                                <div className="portfolio-item col-md-6 col-lg-3 p-2">
                                    <div className="hover-bg">
                                        {" "}
                                        <a
                                            href="img/portfolio/07-large.jpg"
                                            title="Mia Beauty Shoot"
                                            data-lightbox-gallery="gallery1"
                                        >
                                            <div className="hover-text">
                                                <h4>mia</h4>
                                            </div>
                                            <img
                                                src="img/portfolio/07-small.jpg"
                                                className="img-fluid"
                                                alt="Gleamsonic Product Shoot"
                                            />{" "}
                                        </a>{" "}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="portfolio-item col-md-6 col-lg-3 p-2">
                                    <div className="hover-bg">
                                        {" "}
                                        <a
                                            href="img/portfolio/01-large.jpg"
                                            title="Gleamsonic Product Shoot"
                                            data-lightbox-gallery="gallery1"
                                        >
                                            <div className="hover-text">
                                                <h4>@gleamsonic</h4>
                                            </div>
                                            <img
                                                src="img/portfolio/01-small.jpg"
                                                className="img-fluid"
                                                alt="Gleamsonic Product Shoot"
                                            />{" "}
                                        </a>{" "}
                                    </div>
                                </div>
                                <div className="portfolio-item col-md-6 col-lg-3 p-2">
                                    <div className="hover-bg">
                                        {" "}
                                        <a
                                            href="img/portfolio/02-large.jpg"
                                            title="Gleamsonic Product Shoot"
                                            data-lightbox-gallery="gallery1"
                                        >
                                            <div className="hover-text">
                                                <h4>@gleamsonic</h4>
                                            </div>
                                            <img
                                                src="img/portfolio/02-small.jpg"
                                                className="img-fluid"
                                                alt="Gleamsonic Product Shoot"
                                            />{" "}
                                        </a>{" "}
                                    </div>
                                </div>
                                <div className="portfolio-item col-md-6 col-lg-3 p-2">
                                    <div className="hover-bg">
                                        {" "}
                                        <a
                                            href="img/portfolio/03-large.jpg"
                                            title="Gleamsonic Product Shoot"
                                            data-lightbox-gallery="gallery1"
                                        >
                                            <div className="hover-text">
                                                <h4>@gleamsonic</h4>
                                            </div>
                                            <img
                                                src="img/portfolio/03-small.jpg"
                                                className="img-fluid"
                                                alt="Gleamsonic Product Shoot"
                                            />{" "}
                                        </a>{" "}
                                    </div>
                                </div>
                                <div className="portfolio-item col-md-6 col-lg-3 p-2">
                                    <div className="hover-bg">
                                        {" "}
                                        <a
                                            href="img/portfolio/04-large.jpg"
                                            title="Gleamsonic Product Shoot"
                                            data-lightbox-gallery="gallery1"
                                        >
                                            <div className="hover-text">
                                                <h4>@gleamsonic</h4>
                                            </div>
                                            <img
                                                src="img/portfolio/04-small.jpg"
                                                className="img-fluid"
                                                alt="Gleamsonic Product Shoot"
                                            />{" "}
                                        </a>{" "}
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="embed-responsive-16by9 p-2">
                                    <Iframe className="embed-responsive-item"
                                        url="https://www.youtube.com/embed/jcmAYtEFG4Y"
                                        id="myId"
                                        display="initial"
                                        position="relative"
                                        allow="fullscreen" />
                                </div>
                                <div className="embed-responsive-16by9 p-2">
                                    <Iframe className="embed-responsive-item"
                                        url="https://www.youtube.com/embed/dRhdf3Eo9MU?si=0SpfDUPaKis-HXMg"
                                        id="myId"
                                        display="initial"
                                        position="relative"
                                        allow="fullscreen" />
                                </div>
                                <div className="embed-responsive-16by9 p-2">
                                    <Iframe className="embed-responsive-item"
                                        url="https://www.youtube.com/embed/F5Mtk7KwPto"
                                        id="myId"
                                        display="initial"
                                        position="relative"
                                        allow="fullscreen" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Gallery;